import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "g-cell g-cols g-cols--auto" }
const _hoisted_2 = { class: "g-cell g-cols g-cols--narrow" }
const _hoisted_3 = {
  key: 0,
  style: {"line-height":"1px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppIcon = _resolveComponent("AppIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "g-row g-row--appearance_inline g-row--appearance_nowrap g-row--space_xs g-row--align_center vue-table-ordering",
    onClick: _withModifiers($setup.change, ["prevent"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_AppIcon, {
        name: $setup.ICONS[$setup.direction],
        size: "md"
      }, null, 8, ["name"]),
      ($setup.index !== -1)
        ? (_openBlock(), _createElementBlock("sup", _hoisted_3, _toDisplayString($setup.index + 1), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}